import React from 'react';
import "../../styles/profile/profile.css";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs, onSnapshot, updateDoc } from "firebase/firestore";
import { getItem } from '../repositories/movies_and_tvseries';
import ReactTooltip from 'react-tooltip';

import fromImage from "../../images/authentication/no_profile.png";
import editIcon from "../../images/profile/edit_icon.png";
import noImage from "../../images/collections/no_image.png";
import { useSearchContext } from '../chats/searchContext';

const Profile = () => {
    const likesRef = useRef(null);
    const followersRef = useRef(null);
    const followingRef = useRef(null);
    const {setUserId} = useSearchContext();
    const [getYourUserId, setYourUserId] = useState("");
    const [getUserFullName, setUserFullName] = useState("");
    const [getUserName, setUserName] = useState("");
    const [getUserBio, setUserBio] = useState("");
    const [getUserImage, setUserImage] = useState("");
    const [getUserBackdropImage, setUserBackdropImage] = useState("");
    const [getActiveTab, setActiveTab] = useState("likes");
    const [getLikesError, setLikesError] = useState("");
    const [getFollowersError, setFollowersError] = useState("");
    const [getFollowingError, setFollowingError] = useState("");
    const [getLikesList, setLikesList] = useState([]);
    const [getFollowersList, setFollowersList] = useState([]);
    const [getFollowingList, setFollowingList] = useState([]);
    const [getIsLikesLoading, setIsLikesLoading] = useState(true);
    const [getIsFollowersLoading, setIsFollowersLoading] = useState(true);
    const [getIsFollowingLoading, setIsFollowingLoading] = useState(true);

    const onSelectOption = (option) => {
        setActiveTab(option);
    }

    const onGoToUser = (id) => {
        setUserId(id);
    }

    const onRemove = async (personId) => {
        // eslint-disable-next-line no-restricted-globals
        const shouldRemove = confirm("Are you sure you want to stop this user from following you?");
        if (shouldRemove) {
            try {
                const userRef = doc(firebaseFirestore, 'User Details', getYourUserId); 
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    let followersMap = userDoc.data()["followers"] || [];
                    followersMap = followersMap.filter(id => id !== personId);
                    await updateDoc(userRef, { followers: followersMap }, { merge: true });
                }

                const personRef = doc(firebaseFirestore, 'User Details', personId); 
                const personDoc = await getDoc(personRef);
                if (personDoc.exists()) {
                    let followingMap = personDoc.data()["following"] || [];
                    followingMap = followingMap.filter(id => id !== getYourUserId);
                    await updateDoc(personRef, { following: followingMap }, { merge: true });
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };

    const unfollow = async (personId) => {
        // eslint-disable-next-line no-restricted-globals
        const shouldUnfollow = confirm("Are you sure you want to unfollow this user?");
        if (shouldUnfollow) {
            try {
                const userRef = doc(firebaseFirestore, 'User Details', personId); 
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    let followersMap = userDoc.data()["followers"] || [];
                    followersMap = followersMap.filter(id => id !== getYourUserId);
                    await updateDoc(userRef, { followers: followersMap }, { merge: true });
                }

                const personRef = doc(firebaseFirestore, 'User Details', getYourUserId); 
                const personDoc = await getDoc(personRef);
                if (personDoc.exists()) {
                    let followingMap = personDoc.data()["following"] || [];
                    followingMap = followingMap.filter(id => id !== personId);
                    await updateDoc(personRef, { following: followingMap }, { merge: true });
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };

    useEffect(() => {
        const retrieveData = async () => {
            setFollowersError("");
            setFollowingError("");
            try {
                const userRef = doc(firebaseFirestore, 'User Details', getYourUserId); 
                const allUsersRef = collection(firebaseFirestore, 'User Details'); 
                const allUsersSnapshot = await getDocs(allUsersRef);
                            
                const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
                    if (docSnapshot.exists()) {
                        const userData = docSnapshot.data();
                        Object.keys(userData).forEach(async (fieldName) => {
                            if (fieldName.startsWith("following")) {
                                let list = [];
                                const followingListA = userData[fieldName];
                                allUsersSnapshot.forEach((userDoc) => {
                                    if (followingListA.includes(userDoc.id)) {
                                        const details = {
                                            id: userDoc.id,
                                            username: userDoc.data().username,
                                            image: userDoc.data().image,
                                        };

                                        list.push(details);
                                    };
                                });

                                setFollowingList(list);
                            };

                            if (fieldName.startsWith("followers")) {
                                let list = [];
                                const followersListA = userData[fieldName];
                                allUsersSnapshot.forEach((userDoc) => {
                                    if (followersListA.includes(userDoc.id)) {
                                        const details = {
                                            id: userDoc.id,
                                            username: userDoc.data().username,
                                            image: userDoc.data().image,
                                        };

                                        list.push(details);
                                    };
                                });

                                setFollowersList(list);
                            };

                            if (fieldName.startsWith("likes")) {
                                const likesListA = userData[fieldName];
                                const updatedCollections = await Promise.all(
                                    likesListA.map(async (items) => {
                                        let newGenreList = [];
                                        const itemId = items.split("_")[1];
                                        const type = items.split("_")[0];
                                        const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });

                                        details["genres"].forEach((result) => {
                                            const isDuplicate = newGenreList.some(item => item.name === result.name);
                                            if (!isDuplicate) {
                                                newGenreList.push({
                                                    name: result.name,
                                                });
                                            }
                                        });

                                        const genreNames = newGenreList.map(item => item.name);
                                        return { 
                                            ...items, 
                                            id: itemId,
                                            name: `${type === "movie" ? details.title : details.name}`,
                                            image: details.poster_path,
                                            genre: `${genreNames[0] === "" || genreNames[0] === null ? "action" : genreNames[0].toLowerCase()}`,
                                            type: type,
                                        };
                                    })
                                );
            
                                const sortedLikes = updatedCollections.sort((a, b) => {
                                    if (a.name && b.name) {
                                        return a.name.localeCompare(b.name);
                                    }
                                    return 0;
                                });

                                setLikesList(sortedLikes);
                            };

                            if (fieldName.startsWith("fullname")) {
                                const fullNameListA = userData[fieldName];
                                setUserFullName(fullNameListA);
                            };

                            if (fieldName.startsWith("username")) {
                                const usernameListA = userData[fieldName];
                                setUserName(usernameListA);
                            };

                            if (fieldName.startsWith("image")) {
                                const imageListA = userData[fieldName];
                                setUserImage(imageListA);
                            };

                            if (fieldName.startsWith("backdrop_image")) {
                                const backdropImageListA = userData[fieldName];
                                setUserBackdropImage(backdropImageListA);
                            };

                            if (fieldName.startsWith("bio")) {
                                const bioListA = userData[fieldName];
                                setUserBio(bioListA);
                            };
                        });
                    };
                });

                setIsLikesLoading(false);
                setIsFollowersLoading(false);
                setIsFollowingLoading(false);
            
                return () => unsubscribe
            } catch (error) {
                console.log(`Error ${error}`);
                setIsLikesLoading(false);
                setIsFollowersLoading(false);
                setIsFollowingLoading(false);
                setLikesError("Error...");
                setFollowersError("Error...");
                setFollowingError("Error...");
            }
        };

        retrieveData();
    }, [getYourUserId]);

    const getCardSpace = () => {
        if (getLikesList.length > 0 && getActiveTab === "likes" && getIsLikesLoading === false) {
            const parent = document.getElementById('view_profile_screen_available_grid');
            const parentWidth = parent.offsetWidth;
            const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
            const numChildren = Math.floor(parentWidth / childWidth);
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        }
    };

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getLikesList, getActiveTab]);

    useEffect(() => {
        if (getActiveTab === "followers") {
            followersRef.current.classList.add("active");
            followingRef.current.classList.remove("active");
            likesRef.current.classList.remove("active");
        }else if (getActiveTab === "following") {
            followersRef.current.classList.remove("active");
            followingRef.current.classList.add("active");
            likesRef.current.classList.remove("active");
        } else {
            followersRef.current.classList.remove("active");
            followingRef.current.classList.remove("active");
            likesRef.current.classList.add("active");
        }
    }, [getActiveTab]);

    useEffect(() => {
        document.getElementById("profile_screen_header_container_backdrop").style.backgroundImage = `url(${getUserBackdropImage === null || getUserBackdropImage === "" ? null : getUserBackdropImage})`
    }, [getUserBackdropImage]);

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setYourUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    return(
        <div className="profile_screen">
            <div className="profile_screen_header_container">
                <div id="profile_screen_header_container_backdrop" className="profile_screen_header_container_backdrop"></div>
                <div className="profile_screen_header_container_overlay"></div>
                <div className="profile_screen_header_container_content">
                    <img className="profile_screen_header_container_image" src={getUserImage === "" || getUserImage === null ? fromImage : getUserImage} />
                    <div className="profile_screen_header_container_content_column">
                        <p className="profile_screen_header_container_fullname">{getUserFullName === "" ? "Full name not set" : getUserFullName === null ? "Unable to retrieve your full name" : getUserFullName}</p>
                        <p className="profile_screen_header_container_username">{getUserName === "" || getUserName === null ? "Unable to retrieve your username" : `@${getUserName}`}</p>
                        <p className="profile_screen_header_container_bio">{getUserBio === "" ? "Bio not set" : getUserBio === null ? "Unable to retrieve your bio" : getUserBio}</p>
                        {/* <p className="profile_screen_header_container_bio">Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative  Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images Bio fiu gubirbgi  img elements must have an alt prop, either with meaningful text, or an empty 
                            string for decorative images </p> */}
                    </div>
                    <Link data-tip data-for="edit_profile" className="profile_screen_link" to={"/main_back/profile/edit"}><img alt='edit' className="profile_screen_header_container_edit" src={editIcon} /></Link>
                    <ReactTooltip effect='solid' id="edit_profile" place="top">Edit Profile</ReactTooltip>
                </div>
            </div>

            <div className="profile_screen_heads_row">
                <div id="profile_screen_heads_row_con_3" className="profile_screen_heads_row_con_3" ref={likesRef} onClick={() => onSelectOption("likes")}>
                    <p className="profile_screen_heads_row_con_text">{getLikesList.length.toString()}</p>
                    <p className="profile_screen_heads_row_con_text">{getLikesList.length === 1 ? "Like" : "Likes"}</p>
                </div>
                <div id="profile_screen_heads_row_con" className="profile_screen_heads_row_con" ref={followersRef} onClick={() => onSelectOption("followers")}>
                    <p className="profile_screen_heads_row_con_text">{getFollowersList.length.toString()}</p>
                    <p className="profile_screen_heads_row_con_text">{getFollowersList.length === 1 ? "Follower" : "Followers"}</p>
                </div>
                <div id="profile_screen_heads_row_con_2" className="profile_screen_heads_row_con_2" ref={followingRef} onClick={() => onSelectOption("following")}>
                    <p className="profile_screen_heads_row_con_text">{getFollowingList.length.toString()}</p>
                    <p className="profile_screen_heads_row_con_text">Following</p>
                </div>
            </div>

            <div className='profile_screen_block_column'>
                {
                    getActiveTab === "followers"
                    ? <div className="profile_screen_followers_block">
                        {
                            getFollowersError === ""
                            ? getIsFollowersLoading
                                ? <p className="profile_screen_followers_block_error">Loading...</p>
                                : getFollowersList.length > 0
                                    ? getFollowersList.map((followers, index) => (
                                        <div key={index} className="search_screen_block_tab">
                                            <Link 
                                                className='action_container_sub_home_screen_a'
                                                to={
                                                    followers.id === "" || followers.id == null 
                                                    ? null 
                                                    : followers.id !== getYourUserId
                                                    ? `/main_back/search/${followers.username.toLowerCase()}/profile`
                                                    : null
                                                }
                                            >
                                                <div className="search_screen_block_tab_con" onClick={() => onGoToUser(followers.id)}>
                                                    <img alt='profile' className="search_screen_block_tab_image" src={followers.image === "" || followers.image === null ? fromImage : followers.image} />
                                                    <p className="search_screen_block_tab_name">{followers.username}</p>
                                                </div>
                                            </Link>
                
                                            <Link className="search_screen_link" 
                                                to={null}
                                            >
                                                <p className="search_screen_block_tab_view" onClick={() => onRemove(followers.id)}>remove</p>
                                            </Link>                                        
                                        </div>
                                    ))
                                    : <p className="profile_screen_followers_block_error">You don't have any followers <span role='img' aria-label='neutral face.'>😐</span></p>

                            : <p className="profile_screen_followers_block_error">Unable to load your followers list <span role='img' aria-label='smiling face with tear'>🥲</span></p>
                        }
                    </div>
                    : null
                }

                {
                    getActiveTab === "following"
                    ? <div className="profile_screen_following_block">
                        {
                            getFollowingError === ""
                            ? getIsFollowingLoading
                                ? <p className="profile_screen_followers_block_error">Loading...</p>
                                : getFollowingList.length > 0
                                    ? getFollowingList.map((following, index) => (
                                        <div key={index} className="search_screen_block_tab">
                                            <Link 
                                                className='action_container_sub_home_screen_a'
                                                to={
                                                    following.id === "" || following.id == null 
                                                    ? null 
                                                    : following.id !== getYourUserId
                                                    ? `/main_back/search/${following.username.toLowerCase()}/profile`
                                                    : null
                                                }
                                            >
                                                <div className="search_screen_block_tab_con" onClick={() => onGoToUser(following.id)}>
                                                    <img alt='profile' className="search_screen_block_tab_image" src={following.image === "" || following.image === null ? fromImage : following.image} />
                                                    <p className="search_screen_block_tab_name">{following.username}</p>
                                                </div>
                                            </Link>
                
                                            <Link className="search_screen_link" 
                                                to={null}
                                            >
                                                <p className="search_screen_block_tab_view" onClick={() => unfollow(following.id)}>unfollow</p>
                                            </Link>                                        
                                        </div>
                                    ))
                                    : <p className="profile_screen_followers_block_error">You are not following anyone <span role='img' aria-label='neutral face.'>😐</span></p>

                            : <p className="profile_screen_followers_block_error">Unable to load your following list <span role='img' aria-label='smiling face with tear'>🥲</span></p>
                        }
                    </div>
                    : null
                }

                {
                    getActiveTab === "likes"
                    ? <div className="profile_screen_following_block">
                        {
                            getLikesError !== "" && getLikesList.length <= 0
                            ? <p className="profile_screen_followers_block_error">Unable to retrieve the movie and TV you like <span role='img' aria-label='smiling face with tear'>🥲</span></p>          
                            : getIsLikesLoading
                                ? <p className="profile_screen_followers_block_error">Loading...</p>
                                : getLikesList.length > 0
                                    ? <div id="view_profile_screen_available_grid" className="view_profile_screen_available_grid">
                                        {
                                            getLikesList.map((item, index) => (
                                                <Link className="action_container_sub_home_screen_a" to={`/main_back/home/${item.genre}/${item.type}/${item.id}`}><div key={index} id="movie_item" className="movie_item">
                                                    <img
                                                        src={item.image === "" || item.image === null ? noImage : `https://image.tmdb.org/t/p/w500${item.image}`}
                                                        alt={item.name}
                                                        className="movie_poster"
                                                    />
                                                    <p className="movie_item_p">{item.name}</p>
                                                </div></Link>
                                            ))                        
                                        }
                                    </div>
                                    : <p style={{marginTop: "20px", textAlign: "center"}} classNmae="profile_screen_followers_block_error">You have not liked any movies and TV series <span role='img' aria-label='neutral face.'>😐</span></p>
                        }
                    </div>
                    : null
                }
            </div>
        </div>
    );
};

export default Profile;